function txtSearch() {
  var input, filter, container, items, a, i, txtValue;
  input = document.getElementById('myInput');
  filter = input.value.toUpperCase();
  container = document.querySelector(".dropdownList");
  items = container.querySelectorAll('.item');
  // container.classList.remove('hide');

  // Loop through all list items, and hide those who don't match the search query
  for (i = 0; i < items.length; i++) {
    a = items[i];
    txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(filter) > -1) {
      items[i].style.display = "";
      items[i].classList.add('display');
    } else {
      items[i].style.display = "none";
      items[i].classList.remove('display');
    }
  }
}

let counter = 0;
let current = 0;
let listItems = document.querySelectorAll('.dropdownList .item.display');
let flag = false;

listItems[0].classList.add('selected');
listItems[0].focus();


var handleKeyCode = function(e) {
  flag = false;
  var keyCode = e.keyCode;
  var selectedItem = document.querySelector('.dropdownList .item.selected');

    if ((keyCode === 40) || (keyCode === 38)) { // if up or down
      if (listItems.length != 0) {
        var first = listItems[0];
        var last = listItems[listItems.length - 1];

        if (keyCode === 40) { //down arrow
          counter = (selectedItem === last) ? counter : counter + 1;
        } else { // up arrow
          counter = (selectedItem === first) ? counter : counter - 1;
        }
      } else {}

    } else if (keyCode === 13) { // if enter
      if (listItems.length != 0) {
        var selectedSchool = selectedItem.innerText;
        if (document.getElementById('myInput').value != selectedSchool) { //first enter, fill in input bar with value
          document.getElementById('myInput').value = selectedSchool;
        } else if (document.getElementById('myInput').value === selectedSchool) { //second enter, execute search function on that school
          selectedItem.click();
          flag = true;
          document.getElementById('myInput').value  === "";
          document.getElementById('myInput').blur();

        }
      } else {}
    } else {
      counter = 0;
      txtSearch();
      listItems = document.querySelectorAll('.dropdownList .item.display');
    }

    if (listItems.length != 0 && (e.type === "click")) { // if user clicks on button instead of using tabs

      document.querySelectorAll('.dropdownList .item').forEach(function(el) {
        el.classList.add('display');
        el.style.display = "";
        el.classList.remove('selected');
      });
      counter = 0;
      document.querySelectorAll('.dropdownList .item')[0].classList.add('selected');

    } else if (listItems.length != 0 && !flag) {
      document.querySelectorAll('.dropdownList .item').forEach(function(el) { el.classList.remove('selected'); });
      listItems[counter].classList.add('selected');
      listItems[counter].focus();

    } else if (listItems.length != 0 && flag) { // if enter has been clicked twice (a school selected and clicked), reset the counter back to zero
      document.querySelectorAll('.dropdownList .item').forEach(function(el) {
        el.classList.add('display');
        el.style.display = "";
        el.classList.remove('selected');
      });
      counter = 0;
      document.querySelectorAll('.dropdownList .item')[0].classList.add('selected');
    } else {
        console.log("nothing here");
    }
}

module.exports = handleKeyCode;
